export const labeledRadioStyles = {
	radio: (indicateError: boolean, isDirty: boolean) => ({
		p: 0.25,
		mr: 1,

		color: indicateError
			? 'var(--mui-palette-error-main)'
			: isDirty
				? 'var(--mui-palette-success-light)'
				: 'var(--mui-palette-text-secondary)',

		'& .MuiSvgIcon-root': {
			fontSize: 18
		},

		'&.Mui-checked': {
			color: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-primary-main)'
		},

		'&:hover': {
			backgroundColor: 'transparent',
			color: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-text-primary)'
		}
	}),

	formControl: (indicateError: boolean, isDirty: boolean) => ({
		m: 0,
		color: indicateError
			? 'var(--mui-palette-error-main)'
			: isDirty
				? 'var(--mui-palette-success-light)'
				: 'var(--mui-palette-text-primary)',

		'.MuiFormControlLabel-label': {
			fontSize: 14,
			lineHeight: 1.4
		},

		'& .MuiRadio-root.Mui-checked': {
			color: indicateError
				? 'var(--mui-palette-error-main)'
				: isDirty
					? 'var(--mui-palette-success-light)'
					: 'var(--mui-palette-primary-main)'
		}
	})
};
